import { x as s } from "./lit-element-6iugfgmM.js";
import { o as e } from "./if-defined-D-RhGngI.js";
import { n as o } from "./property-BWlAHqg_.js";
var y = Object.defineProperty, a = (l, r, p, d) => {
  for (var n, t = void 0, i = l.length - 1; i >= 0; i--) (n = l[i]) && (t = n(r, p, t) || t);
  return t && y(r, p, t), t;
};
function m(l) {
  class r extends l {
    renderAnchor({ id: d, className: n, ariaHidden: t, labelledby: i, tabindex: h, anchorContent: f = s`<slot></slot>` }) {
      return s`<a
                    id=${d}
                    class=${e(n)}
                    href=${e(this.href)}
                    download=${e(this.download)}
                    target=${e(this.target)}
                    aria-label=${e(this.label)}
                    aria-labelledby=${e(i)}
                    aria-hidden=${e(t ? "true" : void 0)}
                    tabindex=${e(h)}
                    referrerpolicy=${e(this.referrerpolicy)}
                    rel=${e(this.rel)}
                >${f}</a>`;
    }
  }
  return a([o()], r.prototype, "download"), a([o()], r.prototype, "label"), a([o()], r.prototype, "href"), a([o()], r.prototype, "target"), a([o()], r.prototype, "referrerpolicy"), a([o()], r.prototype, "rel"), r;
}
export {
  m as L
};
//# sourceMappingURL=like-anchor-1p1kOy4b.js.map
